import Swiper from 'swiper/bundle';

// Initialize Swiper
const initSwiper = () => {

    // Initialize the latest Swiper
    const latest = document.querySelectorAll('.latest-news');

    for (let i = 0; i < latest.length; i++) {
        let mobileSlides = 2;
        let desktopSlides = 2;
        let spaceBetween = 13;

        if(latest[i].classList.contains('eventsSlider')) {
            desktopSlides = 3;
            spaceBetween = 28;
        }

        latest[i].classList.add('latest-swiper-container-' + i);
        new Swiper('.latest-swiper-container-' + i + ' .latest-swiper', {
            slidesPerView: mobileSlides,
            spaceBetween: spaceBetween,
            navigation: {
                nextEl: '.latest-news.latest-swiper-container-' + i + ' .swiper-button-next',
                prevEl: '.latest-news.latest-swiper-container-' + i + ' .swiper-button-prev',
            },
            breakpoints: {
                768: { slidesPerView: desktopSlides }
            }
        });
    }

    // Initialize the featured Swiper
    const featured = document.querySelectorAll('.featured');

    for (let i = 0; i < featured.length; i++) {
        featured[i].classList.add('featured-swiper-container-' + i);
        new Swiper('.featured-swiper-container-' + i + ' .featuredSwiper', {
            slidesPerView: 1,
            spaceBetween: 32,
            navigation: {
                nextEl: '.featured.featured-swiper-container-' + i + ' .__next',
                prevEl: '.featured.featured-swiper-container-' + i + ' .__prev',
            },
            breakpoints: {
                768: { slidesPerView: 1.4 },
                1200: { slidesPerView: 2.4 }
            },
        });
    }

    // Initialize the testimonials Swiper
    const testimonials = document.querySelectorAll('.testimonials');

    for (let i = 0; i < testimonials.length; i++) {
        testimonials[i].classList.add('testimonials-swiper-container-' + i);
        new Swiper('.testimonials-swiper-container-' + i + ' .testimonialsSwiper', {
            slidesPerView: 1.2,
            spaceBetween: 16,
            navigation: {
                nextEl: '.testimonials.testimonials-swiper-container-' + i + ' .__next',
                prevEl: '.testimonials.testimonials-swiper-container-' + i + ' .__prev',
            },
            breakpoints: {
                768: { slidesPerView: 2.2 },
                1200: { slidesPerView: 3.2 }
            },
        });
    }

    // Initialize the media Swiper
    const media = document.querySelectorAll('.media-gallery');

    for (let i = 0; i < media.length; i++) {
        media[i].classList.add('media-gallery-swiper-container-' + i);
        new Swiper('.media-gallery-swiper-container-' + i + ' .media-gallery-swiper', {
            slidesPerView: 'auto',
            spaceBetween: 16,
            navigation: {
                nextEl: '.media-gallery.media-gallery-swiper-container-' + i + ' .swiper-button-next',
                prevEl: '.media-gallery.media-gallery-swiper-container-' + i + ' .swiper-button-prev',
            },
        });
    }

    // Initialize the banner gallery
    const banner = document.querySelector('.swiperBanner');
    const bannerSwiper = new Swiper(banner, {
        a11y: {
            enabled: true
        },
        loop: true,
        spaceBetween: 0,
        allowTouchMove: false,
        autoplay: {
            delay: 2500,
        },
        navigation: {
            nextEl: '.swiperBannerNext',
            prevEl: '.swiperBannerPrev',
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
        },
    });

    const playPauseButton = document.querySelector('.swiperBannerPlayPause');

    let isPlaying = true;
    playPauseButton.addEventListener('click', () => {
        if (isPlaying) {
            // pause or stop depending on version
            if (bannerSwiper.autoplay.pause) {
                bannerSwiper.autoplay.pause();
            } else {
                bannerSwiper.autoplay.stop();
            }
        } else {
            if (bannerSwiper.autoplay.resume) {
                bannerSwiper.autoplay.resume();
            } else {
                bannerSwiper.autoplay.start();
            }
        }
        isPlaying = !isPlaying;
    });
};

export default initSwiper;